import "./css/LoadingSpinner2.css";

function LoadingSpinner2({
  size = 2,
  thickness = 0.12,
  color = "var(--blue-500)",
  variant = 1,
  style,
}) {
  return (
    <div
      className={`loading-spinner-2 variant-${variant}`}
      style={{
        width: `${size}rem`,
        height: `${size}rem`,
        borderWidth: `${thickness}rem`,
        color: `${color}`,
        ...style,
      }}
    ></div>
  );
}

export default LoadingSpinner2;
